module.exports = __webpack_public_path__ + "static/media/VICTORY-FULL.3c0441a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY-FULL.mp3
// module id = 292
// module chunks = 1 2 3